import { Expose } from 'class-transformer';

export class RoleState {
  @Expose()
  event: string;

  @Expose()
  count: number;
}
